import { render, staticRenderFns } from "./EmergencyOrderContainerList.vue?vue&type=template&id=2cd71d34"
import script from "./EmergencyOrderContainerList.vue?vue&type=script&lang=js"
export * from "./EmergencyOrderContainerList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports